<template>
  <v-container class="px-0 my-3">
    <v-row>
      <v-col class="v-col-12 v-col-lg-3">
        <div class="w-100 bg-white">
          <v-list class="pa-0 d-none d-lg-block">
            <v-list-item prepend-icon="mdi-menu" class="bg-color-2 text-white">Institucional</v-list-item>
            <v-list-item append-icon="mdi-chevron-right" :active="link == 'quemsomos' ? true : false" @click="$router.push('/institucional/quemsomos')" class="link-menu cy-institucional-quemsomos">Quem Somos</v-list-item>
            <v-list-item append-icon="mdi-chevron-right" :active="link == 'politicadeprivacidade' ? true : false" @click="$router.push('/institucional/politicadeprivacidade')" class="link-menu cy-institucional-privacidade">Política de Privacidade</v-list-item>
            <v-list-item append-icon="mdi-chevron-right" :active="link == 'comocomprar' ? true : false" @click="$router.push('/institucional/comocomprar')" class="link-menu cy-institucional-comocomprar">Como Comprar</v-list-item>
            <v-list-item append-icon="mdi-chevron-right" :active="link == 'duvidasfrequentes' ? true : false" @click="$router.push('/institucional/duvidasfrequentes')" class="link-menu cy-institucional-duvidas">Dúvidas Frequentes</v-list-item>
            <v-list-item append-icon="mdi-chevron-right" :active="link == 'locaisehorarios' ? true : false" @click="$router.push('/institucional/locaisehorarios')" class="link-menu cy-institucional-locais">Locais e Horários de Entrega</v-list-item>
            <v-list-item append-icon="mdi-chevron-right" :active="link == 'politicadetroca' ? true : false" @click="$router.push('/institucional/politicadetroca')" class="link-menu cy-institucional-troca">Política de Troca</v-list-item>
          </v-list>
          <div class="d-block d-lg-none px-3">
            <v-menu :location="'top'">
              <template v-slot:activator="{ props }">
                  <v-btn v-bind="props" prepend-icon="mdi-menu" block class="bg-color-2 text-white">Institucional</v-btn>
              </template>
              <v-list class="pa-0">
                <v-list-item append-icon="mdi-chevron-right" :active="link == 'quemsomos' ? true : false" @click="$router.push('/institucional/quemsomos')" class="link-menu">Quem Somos</v-list-item>
                <v-list-item append-icon="mdi-chevron-right" :active="link == 'politicadeprivacidade' ? true : false" @click="$router.push('/institucional/politicadeprivacidade')" class="link-menu">Política de Privacidade</v-list-item>
                <v-list-item append-icon="mdi-chevron-right" :active="link == 'comocomprar' ? true : false" @click="$router.push('/institucional/comocomprar')" class="link-menu">Como Comprar</v-list-item>
                <v-list-item append-icon="mdi-chevron-right" :active="link == 'duvidasfrequentes' ? true : false" @click="$router.push('/institucional/duvidasfrequentes')" class="link-menu">Dúvidas Frequentes</v-list-item>
                <v-list-item append-icon="mdi-chevron-right" :active="link == 'locaisehorarios' ? true : false" @click="$router.push('/institucional/locaisehorarios')" class="link-menu">Locais e Horários de Entrega</v-list-item>
                <v-list-item append-icon="mdi-chevron-right" :active="link == 'politicadetroca' ? true : false" @click="$router.push('/institucional/politicadetroca')" class="link-menu">Política de Troca</v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>
      </v-col>
      <v-col class="v-col-12 v-col-lg-9 px-6 px-lg-0">
        <div class="w-100 bg-white pa-5">
          <v-breadcrumbs class="pa-0">
            <v-breadcrumbs-item class="text-color-0">Home</v-breadcrumbs-item>
            <v-breadcrumbs-divider><v-icon icon="mdi-chevron-right text-color-1"></v-icon></v-breadcrumbs-divider>
            <v-breadcrumbs-item class="text-color-0">Institucional</v-breadcrumbs-item>
            <v-breadcrumbs-divider><v-icon icon="mdi-chevron-right text-color-1"></v-icon></v-breadcrumbs-divider>
          </v-breadcrumbs>
          <v-skeleton-loader :loading="loadingText" type="heading, text, text, text, text, text" width="100%">
            <h1 class="text-color-0 mt-2">{{ titulo }}</h1>
            <div v-if="texto != ''" class="w-100 text-color-0 mt-2 texto-institucional" v-html="texto"></div>
          </v-skeleton-loader>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: "Institucional",
  data() {
    return {
      link: 'quemsomos',
      titulo: 'Quem Somos',
      texto: '',
    }
  },
  computed: {
    ...mapState('main', {
      loadingText: 'loadingText'
    }),
  },
  methods: {
    ...mapActions('main', {
      setConfig: 'setConfig',
      getPolicy: 'getPolicy',
    }),
    Nav(){
      let id = 0;
      this.link = this.$route['params']['texto'];
      switch(this.link){
        case "quemsomos":
          this.titulo = "Quem Somos";
          id = 1;
        break;
        case "politicadeprivacidade":
          this.titulo = "Política de Privacidade";
          id = 2;
        break;
        case "comocomprar":
          this.titulo = "Como Comprar";
          id = 3;
        break;
        case "duvidasfrequentes":
          this.titulo = "Dúvidas Frequentes";
          id = 4;
        break;
        case "locaisehorarios":
          this.titulo = "Locais e horário de entrega";
          id = 5;
        break;
        case "politicadetroca":
          this.titulo = "Política de Troca";
          id = 6;
        break;
      }
      this.getPolicy(id).then(function(response){
        this.texto = response;
      }.bind(this));
    },
  },
  mounted(){
    this.setConfig().then(function(retorno){
      if(retorno){
        this.Nav();
      } else {
        this.emitter.emit('dialogStores');
      }
      this.emitter.emit("sendAnalyticsView", { screen_name: this.$options.name + " - " + this.titulo } );
    }.bind(this))
    .catch(function () {
      this.$router.push("/baixeoapp");
    }.bind(this));
  }
}
</script>